import React from 'react';
import moment from 'moment';

import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import Chip from '@material-ui/core/Chip';
import HistoryIcon from '@material-ui/icons/History';
import LocationOnIcon from '@material-ui/icons/LocationOn';

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			posts: [],
			loading: true,

			queryString: {
				text: '00a8e3',
				button: 'FE6B37',
			},
		};

		this.theme = createMuiTheme({
			palette: {
				primary: {
					main: '#FE6B37',
					contrastText: '#fff',
				},
				secondary: {
					main: '#54595F',
					contrastText: '#fff',
				},
			},
		});
	}

	componentDidMount() {
		this.getJobs();

		const queryString = require('query-string');
		const parsed = queryString.parse(window.location.search);
		this.setState({ queryString: parsed }, () => {
			console.log(parsed, /^(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/i.test(this.state.queryString.text) ? this.state.queryString.text : '#00a8e3');

			this.theme = createMuiTheme({
				palette: {
					primary: {
						main: /^(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/i.test(this.state.queryString.button) ? '#' + this.state.queryString.button : '#FE6B37',
						contrastText: /^[0-9a-fA-F]{3}$/i.test(this.state.queryString.contrast) ? '#' + this.state.queryString.contrast : '#fff',
					},
					secondary: {
						main: '#54595F',
						contrastText: '#fff',
					},
				},
			});
		});
	}

	getJobs = () => {
		fetch('/api/jobs', {
			method: 'GET',
		}).then((response) => {
			if (!response.ok) {
				response.json().then((err) => {
					console.error(err);
					this.setState({ posts: [], loading: false });
				});
			} else {
				return response.json().then((data) => {
					this.setState({ posts: data, loading: false });
				});
			}
		});
	};

	render() {
		return (
			<ThemeProvider theme={this.theme}>
				<div>
					<Grid container>
						{this.state.loading && this.state.posts.length === 0 && (
							<Backdrop open={true}>
								<CircularProgress style={{ color: /^(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/i.test(this.state.queryString.text) ? '#' + this.state.queryString.text : '#00a8e3' }} />
							</Backdrop>
						)}

						{this.state.posts.map((post) => (
							<Grid item xs={12}>
								<Card elevation={3} style={{ margin: 8 }}>
									<CardActionArea component='a' href={'https://recruiting.paylocity.com/Recruiting/Jobs/Details/' + post.id} target='_blank'>
										<div>
											<CardContent>
												<Grid container spacing={2}>
													<Grid item xs>
														<Typography
															component='h2'
															variant='h5'
															style={{
																color: /^(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/i.test(this.state.queryString.text) ? '#' + this.state.queryString.text : '#00a8e3',
															}}
															gutterBottom
														>
															{post.title}
														</Typography>
														{/* <Typography variant='subtitle1' color='textSecondary'>
															{post.description}...
														</Typography> */}

														<Chip
															size='small'
															icon={<LocationOnIcon />}
															label={post.location.Name}
															style={{ cursor: 'pointer' }}
															component='a'
															href={`https://www.google.com/maps/place/${post.location.Address}+${post.location.City}+${post.location.State}+${post.location.Zip}`}
															target='_blank'
														/>
													</Grid>
													<Grid item>
														<Button variant='contained' color='primary'>
															Apply Now
														</Button>
														<br />
														<br />
														<Chip icon={<HistoryIcon />} label={moment(post.time).fromNow()} style={{ cursor: 'pointer' }} />
													</Grid>
												</Grid>
											</CardContent>
										</div>
									</CardActionArea>
								</Card>
							</Grid>
						))}

						{!this.state.loading && (
							<Grid item xs={12}>
								<Card elevation={3} style={{ margin: 8 }}>
									<CardActionArea component='a' href={'https://recruiting.paylocity.com/Recruiting/PublicLeads/New/697c7654-9d6b-4402-b97f-ad4fda2b13cc'} target='_blank'>
										<div>
											<CardContent>
												<Grid container spacing={2}>
													<Grid item xs>
														<Typography
															component='h2'
															variant='h5'
															style={{
																color: /^(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/i.test(this.state.queryString.text) ? '#' + this.state.queryString.text : '#00a8e3',
															}}
															gutterBottom
														>
															Not Finding What You're Looking For?
														</Typography>
														<Typography variant='subtitle1' color='textSecondary'>
															Share your information and we will contact you if new opportunities fitting your qualifications become available
														</Typography>
													</Grid>
													<Grid item>
														<Button variant='contained' color='primary'>
															Share Your Information
														</Button>
													</Grid>
												</Grid>
											</CardContent>
										</div>
									</CardActionArea>
								</Card>
							</Grid>
						)}
					</Grid>
				</div>
			</ThemeProvider>
		);
	}
}

export default App;
